import React, { useState } from 'react';
import { hexToRGB, SetImage } from 'common/utils/helpers';

const PolygonIntersectionPopup = ({ currentIntersectionedPolygons, selectIntersectionPolygon }) => {
  const [currentHoveredPolygon, setCurrentHoveredPolygon] = useState(null);

  return (
    <div className="DeviceMapOverlay_CenterDiv_Intersection scroll-component">
      <ul className="PolygonContentSection_List_Items">
        {currentIntersectionedPolygons.map((polygonItem) => (
          <li
            className="PolygonContentSection_List_Item"
            key={polygonItem.name}
            style={{
              backgroundColor:
                currentHoveredPolygon === polygonItem.name ? hexToRGB(polygonItem.options.color) : 'transparent'
            }}
            onMouseEnter={() => setCurrentHoveredPolygon(polygonItem.name)}
            onMouseLeave={() => setCurrentHoveredPolygon(null)}
            onClick={() => selectIntersectionPolygon(polygonItem)}
          >
            <div className="PolygonContentSection_List_Item_Icon">
              {SetImage(polygonItem.options.color, polygonItem.options.fillColor)}
            </div>

            <div className="PolygonContentSection_List_Item_Name">{polygonItem.name}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PolygonIntersectionPopup;
